"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransactions = exports.sendTransaction = exports.signTransaction = exports.configure = exports.exportPrivateKey = exports.getRecentBlockhash = exports.getBalance = exports.getAddress = void 0;
function sendSnapMethod(request, snapId) {
    return __awaiter(this, void 0, void 0, function* () {
        return window.ethereum.send({
            method: snapId,
            params: [request],
        });
    });
}
function getAddress() {
    return __awaiter(this, void 0, void 0, function* () {
        return sendSnapMethod({ method: 'sol_getAddress' }, this.snapId);
    });
}
exports.getAddress = getAddress;
function getBalance() {
    return __awaiter(this, void 0, void 0, function* () {
        return sendSnapMethod({ method: 'sol_getBalance' }, this.snapId);
    });
}
exports.getBalance = getBalance;
function getRecentBlockhash() {
    return __awaiter(this, void 0, void 0, function* () {
        return sendSnapMethod({ method: 'sol_getRecentBlockhash' }, this.snapId);
    });
}
exports.getRecentBlockhash = getRecentBlockhash;
function exportPrivateKey() {
    return __awaiter(this, void 0, void 0, function* () {
        return sendSnapMethod({ method: 'sol_exportPrivateKey' }, this.snapId);
    });
}
exports.exportPrivateKey = exportPrivateKey;
function configure(configuration) {
    return __awaiter(this, void 0, void 0, function* () {
        return sendSnapMethod({ method: 'sol_configure', params: { configuration } }, this.snapId);
    });
}
exports.configure = configure;
function signTransaction(transaction) {
    return __awaiter(this, void 0, void 0, function* () {
        return sendSnapMethod({ method: 'sol_signTransaction', params: { transaction } }, this.snapId);
    });
}
exports.signTransaction = signTransaction;
function sendTransaction(signedTransaction) {
    return __awaiter(this, void 0, void 0, function* () {
        return sendSnapMethod({ method: 'sol_sendTransaction', params: { signedTransaction } }, this.snapId);
    });
}
exports.sendTransaction = sendTransaction;
function getTransactions() {
    return __awaiter(this, void 0, void 0, function* () {
        return sendSnapMethod({ method: 'sol_getTransactions' }, this.snapId);
    });
}
exports.getTransactions = getTransactions;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWV0aG9kcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9tZXRob2RzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUdBLFNBQWUsY0FBYyxDQUFJLE9BQWlDLEVBQUUsTUFBYzs7UUFDaEYsT0FBTyxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQztZQUMxQixNQUFNLEVBQUUsTUFBTTtZQUNkLE1BQU0sRUFBRSxDQUFDLE9BQU8sQ0FBQztTQUNsQixDQUFDLENBQUM7SUFDTCxDQUFDO0NBQUE7QUFFRCxTQUFzQixVQUFVOztRQUM5QixPQUFPLGNBQWMsQ0FBQyxFQUFFLE1BQU0sRUFBRSxnQkFBZ0IsRUFBRSxFQUFFLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUNuRSxDQUFDO0NBQUE7QUFGRCxnQ0FFQztBQUVELFNBQXNCLFVBQVU7O1FBQzlCLE9BQU8sY0FBYyxDQUFDLEVBQUUsTUFBTSxFQUFFLGdCQUFnQixFQUFFLEVBQUUsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ25FLENBQUM7Q0FBQTtBQUZELGdDQUVDO0FBRUQsU0FBc0Isa0JBQWtCOztRQUN0QyxPQUFPLGNBQWMsQ0FBQyxFQUFFLE1BQU0sRUFBRSx3QkFBd0IsRUFBRSxFQUFFLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUMzRSxDQUFDO0NBQUE7QUFGRCxnREFFQztBQUVELFNBQXNCLGdCQUFnQjs7UUFDcEMsT0FBTyxjQUFjLENBQUMsRUFBRSxNQUFNLEVBQUUsc0JBQXNCLEVBQUUsRUFBRSxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDekUsQ0FBQztDQUFBO0FBRkQsNENBRUM7QUFFRCxTQUFzQixTQUFTLENBQTJCLGFBQXlCOztRQUNqRixPQUFPLGNBQWMsQ0FBQyxFQUFFLE1BQU0sRUFBRSxlQUFlLEVBQUUsTUFBTSxFQUFFLEVBQUUsYUFBYSxFQUFFLEVBQUUsRUFBRSxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDN0YsQ0FBQztDQUFBO0FBRkQsOEJBRUM7QUFFRCxTQUFzQixlQUFlLENBQTJCLFdBQW1COztRQUNqRixPQUFPLGNBQWMsQ0FBQyxFQUFFLE1BQU0sRUFBRSxxQkFBcUIsRUFBRSxNQUFNLEVBQUUsRUFBRSxXQUFXLEVBQUUsRUFBRSxFQUFFLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUNqRyxDQUFDO0NBQUE7QUFGRCwwQ0FFQztBQUVELFNBQXNCLGVBQWUsQ0FBMkIsaUJBQXlCOztRQUN2RixPQUFPLGNBQWMsQ0FBQyxFQUFFLE1BQU0sRUFBRSxxQkFBcUIsRUFBRSxNQUFNLEVBQUUsRUFBRSxpQkFBaUIsRUFBRSxFQUFFLEVBQUUsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3ZHLENBQUM7Q0FBQTtBQUZELDBDQUVDO0FBRUQsU0FBc0IsZUFBZTs7UUFDbkMsT0FBTyxjQUFjLENBQUMsRUFBRSxNQUFNLEVBQUUscUJBQXFCLEVBQUUsRUFBRSxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDeEUsQ0FBQztDQUFBO0FBRkQsMENBRUMifQ==